import { Inventory } from '@cibo/core'
import DeleteRounded from '@mui/icons-material/DeleteRounded'
import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid-pro'
import { useTranslation } from 'react-i18next'
import { useDeleteInventory } from '../../../../features/Inventories/queries/useDeleteInventory'

/**
 * @todo
 * check and remove this as soon as the MUI GridActionsCellItem typings are updated
 */
const requiredProps = {} as {
  nonce: any
  onResize: any
  onResizeCapture: any
}

export const useRowActionsColumn = () => {
  const { t } = useTranslation('impact/InventoriesList')
  const deleteInventory = useDeleteInventory()

  return {
    field: 'actions',
    type: 'actions',
    width: 24,
    getActions: (params: GridRowParams<Inventory>) => {
      const actions = [
        <GridActionsCellItem
          icon={<DeleteRounded />}
          onClick={e => {
            deleteInventory.mutateAsync(params.row)
          }}
          label={t('delete')}
          disabled={deleteInventory.isLoading}
          showInMenu
          {...requiredProps}
        />,
      ]

      return actions
    },
  }
}
